// extracted by mini-css-extract-plugin
export default {"confirmationPopUp":"ConfirmationOverlay_confirmationPopUp__OAvna","backgroundArea":"ConfirmationOverlay_backgroundArea__HhK6J"};